import * as React from 'react';
import './TrialPublicationTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TrialPublicationTypeActions from '../../../actions/trialPublicationTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface ITrialPublicationTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  trialPublicationType: Dtos.TrialPublicationType[];
  loadingTrialPublicationTypes: boolean;
  loadTrialPublicationTypesSuccess: boolean;
  loadTrialPublicationTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface ITrialPublicationTypesPageActions {
  clearTrialPublicationTypes: TrialPublicationTypeActions.ITrialPublicationTypeClearActionCreator;
  loadTrialPublicationTypes: TrialPublicationTypeActions.ITrialPublicationTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TrialPublicationTypeActions.ITrialPublicationTypeFilterActionCreator;
}
type TrialPublicationTypesPageProps = ITrialPublicationTypesPageProps & ITrialPublicationTypesPageActions;
class TrialPublicationTypesPage extends React.PureComponent<TrialPublicationTypesPageProps, any> {
  constructor(props: TrialPublicationTypesPageProps) {
    super(props);
    this.clearTrialPublicationTypes = this.clearTrialPublicationTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialPublicationTypes
    } = this.props;
    loadTrialPublicationTypes();
  }
  componentWillReceiveProps(nextProps: TrialPublicationTypesPageProps) {}
  componentDidUpdate(prevProps: TrialPublicationTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TrialPublicationTypesPageProps) {}
  componentWillUnmount() {
    this.clearTrialPublicationTypes();
  }
  clearTrialPublicationTypes() {
    this.props.clearTrialPublicationTypes();
  }
  showTrialPublicationTypes(): boolean {
    const {
      loadingTrialPublicationTypes,
      loadTrialPublicationTypesSuccess
    } = this.props;
    if (!loadingTrialPublicationTypes && loadTrialPublicationTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrialPublicationTypes
    } = this.props;
    return <TrialLookupsLayout loading={loadingTrialPublicationTypes} permission={Dtos.Permission.TrialPublicationTypesView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TrialPublicationTypesPage" data-sentry-source-file="TrialPublicationTypesPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Trial Publication Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPublicationTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/trialPublicationTypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTrialPublicationTypes() ? "Loading Trial Publication Types" : null}
            {this.showTrialPublicationTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      trialPublicationType
    } = this.props;
    if (!trialPublicationType || trialPublicationType.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no trial publication types to view.</span>
            </div>;
    }
    const showPagination = trialPublicationType.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={trialPublicationType} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : trialPublicationType.length} pageSize={showPagination ? undefined : trialPublicationType.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no trial publication types to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/trialPublicationTypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialPublicationTypesPageProps): ITrialPublicationTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.trialPublicationTypes.formFilter,
    trialPublicationType: state.trialPublicationTypes.formFilteredData,
    loadingTrialPublicationTypes: state.trialPublicationTypes.loadState && state.trialPublicationTypes.loadState.status == RequestState.Pending,
    loadTrialPublicationTypesSuccess: state.trialPublicationTypes.loadState && state.trialPublicationTypes.loadState.status == RequestState.Success,
    loadTrialPublicationTypesFailure: state.trialPublicationTypes.loadState && state.trialPublicationTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): ITrialPublicationTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTrialPublicationTypes: bindActionCreators(TrialPublicationTypeActions.LoadTrialPublicationType, dispatch),
    clearTrialPublicationTypes: bindActionCreators(TrialPublicationTypeActions.Clear, dispatch),
    filter: bindActionCreators(TrialPublicationTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialPublicationTypesPage);